// @ts-nocheck
import { PhoneIncoming, Pause, AlertCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

/**
 * アクション必要パネル
 * 待機中の着信や保留中の通話など、今すぐ対応が必要な項目を表示
 */
export default function ActionRequiredPanel({ queuedCallsCount, heldCallsCount }) {
  const navigate = useNavigate()

  // アクションが必要な項目がない場合は何も表示しない
  if (queuedCallsCount === 0 && heldCallsCount === 0) {
    return null
  }

  return (
    <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl shadow-lg p-6 text-white">
      <div className="flex items-center gap-3 mb-4">
        <AlertCircle className="w-6 h-6 animate-pulse" />
        <h2 className="text-xl font-bold">今すぐ対応が必要</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* 待機中の着信 */}
        {queuedCallsCount > 0 && (
          <button
            onClick={() => navigate('/queue')}
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-lg p-4 transition-all duration-200 text-left border-2 border-white/20 hover:border-white/40"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <PhoneIncoming className="w-5 h-5" />
                <span className="font-semibold">待機中の着信</span>
              </div>
              <span className="text-3xl font-bold">{queuedCallsCount}</span>
            </div>
            <p className="text-sm text-white/80">クリックしてキューを確認</p>
          </button>
        )}

        {/* 保留中の通話 */}
        {heldCallsCount > 0 && (
          <button
            onClick={() => navigate('/queue')}
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-lg p-4 transition-all duration-200 text-left border-2 border-white/20 hover:border-white/40"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Pause className="w-5 h-5" />
                <span className="font-semibold">保留中の通話</span>
              </div>
              <span className="text-3xl font-bold">{heldCallsCount}</span>
            </div>
            <p className="text-sm text-white/80">クリックして確認</p>
          </button>
        )}
      </div>
    </div>
  )
}
